import $ from 'jquery';
import 'jquery.easing';
import 'jquery.scrollto/jquery.scrollTo.min';

export default (element, callback = () => {}) => {
  $(window)
    .stop()
    .scrollTo($(element), {
      duration: 700,
      easing: 'easeInOutQuint',
      offset: window.innerWidth > 1040 ? -200 : -100,
      onAfter: callback
    });
};
